module.exports = __webpack_public_path__ + "cd7dce748d9ddc747c78c3141b7238ae.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/prize_4.png
// module id = 85
// module chunks = 0